__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@customer-platform/app-base";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "5.6.1", () => (() => (__webpack_require__(956))), 1);
			register("@customer-platform/shared", "1.0.0", () => (() => (__webpack_require__(7761))), 1);
			register("antd", "5.29.3", () => (() => (__webpack_require__(2179))), 1);
			register("axios", "1.15.0", () => (() => (__webpack_require__(6981))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(8325))), 1);
			register("react-router-dom", "6.30.1", () => (() => (__webpack_require__(7028))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(9204))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(2306))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(3696))), 1);
			register("styled-components", "5.3.11", () => (() => (__webpack_require__(2514))), 1);
			register("styled-components", "6.1.19", () => (() => (__webpack_require__(5142))), 1);
			register("sysone-api-mapper", "1.0.201", () => (() => (__webpack_require__(7744))), 1);
			initExternal(3572);
			initExternal(5588);
			initExternal(3419);
			initExternal(9505);
			initExternal(1033);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};